/**
 * Shared Warmup flag: renders a country name as a CDN flag IMAGE (not an emoji — Android can't draw
 * subdivision flags like England/Scotland). Reuses the same name→code + flagcdn helpers as the World Cup and
 * Footballer Quiz surfaces. Renders nothing on an unknown/empty country (graceful).
 */

import { memo, useMemo } from 'react';
import { Image } from 'expo-image';
import { StyleSheet } from 'react-native';
import { countryCodeFromName } from '../../../src/quiz/helpers/countryFlag.helper';
import { getFlagCdnUrl } from '../../../src/worldcup/helpers/flagCdn.helper';

interface GameFlagProps {
  country: string | null | undefined;
  width?: number;
  height?: number;
}

const styles = StyleSheet.create({ image: { borderRadius: 3 } });

function GameFlagInner({ country, width = 22, height = 15 }: GameFlagProps) {
  const uri = useMemo(() => {
    const code = country ? countryCodeFromName(country) : null;
    return code ? getFlagCdnUrl(code) : null;
  }, [country]);

  if (!uri) return null;
  return (
    <Image
      source={{ uri, cacheKey: uri }}
      style={[styles.image, { width, height }]}
      contentFit="cover"
      cachePolicy="memory-disk"
      accessibilityLabel={country ?? undefined}
    />
  );
}

export const GameFlag = memo(GameFlagInner);
